import { InvoicesApiGetTotalInvoiceAmountsRequest } from "../../GeneratedClients/FreeBillApi"
import { apiService } from "../../apiService"

const fetchTotalAmounts = async(resource: "drafts" | "invoices", params: InvoicesApiGetTotalInvoiceAmountsRequest) => {
  try {
    const { data: totalAmounts } = resource === 'invoices' ? await apiService.InvoicesApi.getTotalInvoiceAmounts(params) : await apiService.DraftsApi.getTotalDraftAmounts(params)
    return totalAmounts  
  } catch (error) {
    console.log(error)
  }
}

export default fetchTotalAmounts